import { render } from "./Initiate.vue?vue&type=template&id=63d729c4"
import script from "./Initiate.vue?vue&type=script&lang=js"
export * from "./Initiate.vue?vue&type=script&lang=js"

import "./Initiate.vue?vue&type=style&index=0&id=63d729c4&lang=scss"

import exportComponent from "/Users/ChenHao/www/xiaohangjia/zhy_dataview_fe/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__